<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <section>
    <b-list-group>
      <b-list-group-item
        v-for="(item, index) in items"
        :key="index"
        class="d-flex justify-content-between align-items-center"
        style="font-size: 16px;min-height: 54px;line-height: 25px"
        :href="'/detail?id=' + item.newsId "
        target="XZ"
        dark
      >
        <span style="font-size:16px;">
          <b-icon />
          <!-- <b-badge variant="danger" style="margin-right: 5px" v-if="index < 3">最新</b-badge> -->
          <span v-if="item.top" style="color: red;">【置顶】</span>{{ item.title }}
          <b-badge variant="danger" style="margin-right: 5px;" v-if="item.isNew">New</b-badge>
        </span>
        {{ item.createTime }}
      </b-list-group-item>
    </b-list-group>

    <b-pagination-nav
      align="center"
      class="mt20"
      :number-of-pages="pagination.totalPage"
      :value="pagination.page"
      base-url="#"
      first-text="首页"
      prev-text="上一页"
      next-text="下一页"
      last-text="末页"
      @change="pageChangeListener"
    ></b-pagination-nav>
  </section>
</template>

<script>
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import { formatDate } from '@/utils/date';

export default {
  name: 'NewsListComponent',
  props: {
    type: {
      required: true,
      type: Number
    },
    keyword: {
      type: String
    }
  },
  data() {
    return {
      items: [],
      reqBody: { page: 1, pageSize: 15, title: this.keyword, type: this.type },
      pagination: {}
    };
  },

  activated() {},

  mounted() {
    this.requestNews();
  },

  unmounted() {},

  created() {},

  methods: {
    requestNews(isSearchBtnClick) {
      if (isSearchBtnClick) {
        this.reqBody.page = 1;
        this.reqBody.title = this.keyword;
      }
      axiosServer({
        url: urls.svpNews,
        params: this.reqBody
      }).then(resp => {
        resp.data.page.list.forEach(item => {
          item.dateFormate = formatDate(new Date(item.createTime.replace(/-/g,'/')), 'MM/dd');
          let timePeriod = new Date().getTime() - new Date(item.createTime.replace(/-/g,'/'));
          let oneMonth = 30 * 24 * 60 * 60 * 1000;
          item.isNew = timePeriod < oneMonth;
        });
        // this.items = resp.data.page.list;

        this.items = resp.data.page.list;
        let page = resp.data.page;
        this.pagination = { page: page.page + 1, pageSize: page.pageSize, total: page.total, totalPage: page.totalPage };
      });
    },

    pageChangeListener(page) {
      this.reqBody.page = page;
      this.requestNews();
    }
  }
};
</script>

